/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import { useTableKeyboardNavigation as f } from "../navigation/hooks.mjs";
import { disableNavigatableContainer as b } from "@progress/kendo-react-common";
const p = (t) => {
  const {
    ariaSort: i,
    colSpan: n,
    rowSpan: o,
    columnId: l,
    navigatable: e,
    ariaColumnIndex: c,
    ariaLabel: s,
    ariaSelected: m,
    ariaDescription: h,
    ...d
  } = t, u = f(l, e), a = r.useRef(null);
  return r.useEffect(() => {
    a.current && e && b(a.current);
  }, [e]), /* @__PURE__ */ r.createElement(
    "th",
    {
      ref: a,
      "aria-sort": i,
      "aria-label": s,
      "aria-colindex": c,
      "aria-selected": m,
      colSpan: n,
      rowSpan: o,
      ...u,
      ...d
    },
    t.children
  );
};
p.displayName = "KendoReactHeaderThElement";
export {
  p as HeaderThElement
};
